import { CreditCard, PanelsTopLeft, ShieldCheck } from "lucide-react";
import { InfoRow } from "@/shared/components/ui/InfoRow";

export function StripeBenefits({ connected }: { connected: boolean }) {
  const benefits = [
    {
      title: "Collect payments",
      description: connected
        ? "Accept customer payments and receive payouts through Stripe."
        : "Accept customer payments and receive payouts through Stripe once your account is approved.",
      icon: CreditCard,
    },
    {
      title: "Handled securely by Stripe",
      description: "Stripe handles account setup, identity verification, and payment processing.",
      icon: ShieldCheck,
    },
    {
      title: "Manage everything in Stripe",
      description: "View payments, manage payouts, and update your account in the Stripe Dashboard.",
      icon: PanelsTopLeft,
    },
  ];

  return (
    <ul aria-label="About Stripe" className="divide-y divide-border">
      {benefits.map(({ title, description, icon: Icon }) => (
        <li key={title}>
          <InfoRow
            title={title}
            caption={<span className="text-sm">{description}</span>}
            icon={<Icon className="mt-0.5 size-[22px] text-primary" aria-hidden="true" />}
            bold
            className="rounded-none border-0 bg-transparent [&>div]:items-start [&>div]:px-0"
          />
        </li>
      ))}
    </ul>
  );
}
